module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.epigram && _vm.epigram.versions) ? _c('div', {
    staticClass: "greek-text"
  }, [_c('div', {
    staticClass: "greek-translation dropdown"
  }, [_c('p', {
    on: {
      "click": _vm.onGreekDropdownClick
    }
  }, [_vm._v("\n        Texte source grec\n        "), _c('span', {
    staticClass: "glyphicon glyphicon-chevron-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "border-bottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-drop"
  }, [_c('div', {
    staticClass: "dropdown-content"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.versionLanguage(_vm.epigram.versions, {
        greekText: true
      }).text_translated)
    }
  })])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e51218e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/epigram/GreekText.vue
// module id = 105
// module chunks = 0